"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Div = _interopRequireDefault(require("./Div.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeSpacing = _interopRequireDefault(require("../Theme/ThemeSpacing.js"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A `Div` using the Flex layout model
 */
class Flex extends _react.default.PureComponent {
  /**
   * Render.
   *
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Div.default, { ...this.props,
      style: this.styles
    });
  }
  /**
   * Styles.
   *
   * @type {Object}
   */


  get styles() {
    return {
      alignContent: this.props.alignContent,
      alignItems: this.props.alignItems,
      alignSelf: this.props.alignSelf,
      display: !this.props.hidden ? !this.props.inline ? "flex" : "inline-flex" : "none",
      flexBasis: this.props.flexBasis,
      flexGrow: this.props.flexGrow,
      flexDirection: !this.props.columnar ? "column" : "row",
      flexShrink: this.props.flexShrink,
      flexWrap: this.props.flexWrap ? "wrap" : undefined,
      gap: (0, _ThemeSpacing.default)(this.props.gap),
      justifyContent: this.props.justifyContent,
      justifyItems: this.props.justifyItems,
      justifySelf: this.props.justifySelf,
      ...this.props.style
    };
  }

  static propTypes = {
    alignContent: _propTypes.default.string,
    alignItems: _propTypes.default.string,
    alignSelf: _propTypes.default.string,
    columnar: _propTypes.default.bool,
    flexBasis: _propTypes.default.string,
    flexGrow: _propTypes.default.number,
    flexShrink: _propTypes.default.number,
    flexWrap: _propTypes.default.bool,
    gap: _propTypes.default.number,
    inline: _propTypes.default.bool,
    justifyContent: _propTypes.default.string,
    justifyItems: _propTypes.default.string,
    justifySelf: _propTypes.default.string,
    style: _propTypes.default.object
  };
  static defaultProps = {
    columnar: false,
    flexWrap: false,
    gap: 1,
    inline: false
  };
}

var _default = Flex;
exports.default = _default;